import StoreListContainer from './StoreListContainer';
export default StoreListContainer;
